export default __webpack_public_path__ + "static/media/Screenshot (1137).018db268.png";